import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export var getNumItemsFromBreakpoints = function getNumItemsFromBreakpoints(breakpoints, screen, defaultNumItems) {
  if (!breakpoints) {
    return defaultNumItems;
  }
  var attributes = breakpoints.find(function (element) {
    return element.screen === screen;
  });
  if (attributes) {
    return attributes.items;
  }
  return defaultNumItems;
};